import { isAuthenticated, logout, prepareTabSession } from '../services/auth/authService';
import { canAccess as canAccessModule } from '../services/permission/permissionService';
import { readLegacyCompatSession } from '../services/legacy/legacySession';
import { getLegacyAuthorizationHeader } from '../services/legacy/legacyHeaders';

export function legacyAuthorizationHeader() {
  return getLegacyAuthorizationHeader();
}

export const RedirectToLogin = () => {
  prepareTabSession();
  if (isAuthenticated()) {
    return;
  }
  logout({ reason: 'session_timeout' });
};

export const ReturnUserName = () => {
  return readLegacyCompatSession().username;
};

export const canAccess = (modulo) => canAccessModule(modulo);
